import { render, staticRenderFns } from "./GasEstimate.vue?vue&type=template&id=29225940&scoped=true&"
import script from "./GasEstimate.vue?vue&type=script&lang=ts&"
export * from "./GasEstimate.vue?vue&type=script&lang=ts&"
import style0 from "./GasEstimate.vue?vue&type=style&index=0&id=29225940&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29225940",
  null
  
)

export default component.exports